import React from "react";

export const AuthLayout: React.FC = ({ children }) => {
  return <div>{children}</div>;
};
